var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',[_c('md-card-header',{staticClass:"card-chart",attrs:{"data-background-color":_vm.dataBackgroundColor}},[_c('div',{staticClass:"ct-chart-line",attrs:{"id":_vm.chartId}})]),_c('md-card-content',[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }